import type { SubscriptionPlan, SubscriptionStatus } from '@unriddle/db/types';

interface Subscription {
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
}

interface User {
  subscription?: Subscription[];
}

export const hasActivePremiumPlan = (user: User | null): boolean => {
  if (!user || !user.subscription || user.subscription.length === 0) {
    return false;
  }

  const premiumPlans: SubscriptionPlan[] = [
    'PRO',
    'PREMIUM',
    'UNLIMITED',
    'TEAM',
    'FRIEND',
  ];

  return user.subscription.some(
    (sub) => premiumPlans.includes(sub.plan) && sub.status === 'ACTIVE',
  );
};
